import React, { FunctionComponent } from "react";

interface Props {
    label: string;
    onClick: React.MouseEventHandler<HTMLDivElement>
}

export const ButtonBorder: FunctionComponent<Props> = ({ label, onClick }) =>
    <div className="button-border" onClick={onClick}>
        <p>{label}</p>
        <img src={"/assets/images/responsive/icons/arrow-black.svg"} width="24" height="24" alt={"boutton de retour � l'arriere"} />
    </div>
